export const enum EModalEvent {
  Show   = 'Modal:Show',
  Close  = 'Modal:Close'
}

export enum ESize {
  Small      = 'small',     // appoknál
  Large      = 'large',     // ...
  Wide       = 'wide',      // ...
  Responsive = 'responsive' // weblapoknál
}

export enum EOverlay {
  Hidden  = 'hidden',
  Visible = 'visible'
}

export type TCloseButton = 'custom' | 'none'

export interface IBaseModalProps {
  readonly size?:                   ESize
  readonly width?:                  string
  readonly height?:                 string
  readonly overlay?:                EOverlay
  readonly onClose?:                TVoidCallback
  readonly children?:               HTMLElement | DocumentFragment
  readonly className?:              string
  readonly willRemove?:             boolean // ha a bezárásnál remove-oljuk a modal-t
  readonly canAnimate?:             boolean
  readonly isClosable?:             boolean
  readonly closeButtonType?:        TCloseButton
  readonly canWindowAnimate?:       boolean // a window slide in/out animációja
  readonly willRestoreScrollBar?:   boolean // csak responsive-nál használható: állítsa-e a scrollbart vagy se
  readonly canCloseOnOverlayClick?: boolean // overlay-re click-elve bezáródik a Modal
}

export interface IModalProps extends IBaseModalProps {
  callback?: (modal: HTMLElement) => void
  parent?: HTMLElement
}
